<template>
  <p class="internal-redirection-link" @click="handleClick">
    {{ content }}
  </p>
</template>
<script>
export default {
  name: 'HeroIcons',
  props: ['content', 'destination'],
  methods: {
    handleClick() {
      if (this.destination.includes('noBusinessDone')) {
        this.$store.commit('errors/updateUserMessage', {
          isActive: true,
          popupType: 'NotFreelancer',
        })
        return
      }
      this.$router.push(this.destination)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/globalUiComponents/InternalLink.vue